// extracted by mini-css-extract-plugin
export default {"PdfViewer":"PdfViewer_PdfViewer__ZqOXz","IosPdfViewer":"PdfViewer_IosPdfViewer__a66e2","canvasDisplay":"PdfViewer_canvasDisplay__SNFls"};